import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { WIDGET_PAGE_NAME } from '../../constants/service/app/widgetConstants';
import SubPageCreateContainer from '../../containers/widget/SubPageCreateContainer';

const SubPageCreate = () => {
  return (
    <PageTemplate pageName={WIDGET_PAGE_NAME.SUB_PAGE_CRATE}>
      <SubPageCreateContainer />
    </PageTemplate>
  );
};

export default SubPageCreate;
